import { render } from "./other-layout.vue?vue&type=template&id=100cf21c&scoped=true"
import script from "./other-layout.vue?vue&type=script&lang=ts"
export * from "./other-layout.vue?vue&type=script&lang=ts"

import "./other-layout.vue?vue&type=style&index=0&id=100cf21c&lang=less&scoped=true"
script.render = render
script.__scopeId = "data-v-100cf21c"

export default script